// 생년월일 유효성 검증
export const validateBirthDate = (birthDate: string): {
  isValid: boolean;
  errorMessage?: string;
} => {
  // 빈 값 체크
  if (!birthDate.trim()) {
    return { isValid: false, errorMessage: '생년월일을 입력해주세요.' };
  }

  // 8자리 숫자 형식 체크
  if (!/^\d{8}$/.test(birthDate)) {
    return { isValid: false, errorMessage: 'YYYYMMDD 형식의 8자리 숫자로 입력해주세요.' };
  }

  const year = parseInt(birthDate.substring(0, 4));
  const month = parseInt(birthDate.substring(4, 6));
  const day = parseInt(birthDate.substring(6, 8));

  // 연도 범위 체크 (1950년 이하 제한)
  const currentYear = new Date().getFullYear();
  if (year <= 1950) {
    return { isValid: false, errorMessage: '1950년생 이하는 신청할 수 없습니다.' };
  }

  // 미래 날짜 체크
  if (year > currentYear) {
    return { isValid: false, errorMessage: '미래의 생년월일은 입력할 수 없습니다.' };
  }

  // 월 범위 체크
  if (month < 1 || month > 12) {
    return { isValid: false, errorMessage: '올바른 월을 입력해주세요 (01-12).' };
  }

  // 일 범위 체크
  if (day < 1 || day > 31) {
    return { isValid: false, errorMessage: '올바른 일을 입력해주세요 (01-31).' };
  }

  // 실제 날짜 유효성 체크 (2월 30일, 4월 31일 등 불가능한 날짜 체크)
  const testDate = new Date(year, month - 1, day);
  if (testDate.getFullYear() !== year ||
    testDate.getMonth() !== month - 1 ||
    testDate.getDate() !== day) {
    return { isValid: false, errorMessage: '존재하지 않는 날짜입니다.' };
  }

  // 너무 어린 나이 체크 (3세 미만)
  const today = new Date();
  const birthDateObj = new Date(year, month - 1, day);
  const age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();
  const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate()) ? age - 1 : age;

  if (actualAge < 3) {
    return { isValid: false, errorMessage: '3세 이상부터 신청 가능합니다.' };
  }

  return { isValid: true };
};

/**
 * 생년월일(YYYYMMDD)로 만 나이를 계산합니다.
 * 형식이 올바르지 않으면 null을 반환합니다.
 */
export const getAge = (birthDate: string): number | null => {
  if (!/^\d{8}$/.test(birthDate)) return null;
  const year = parseInt(birthDate.substring(0, 4));
  const month = parseInt(birthDate.substring(4, 6));
  const day = parseInt(birthDate.substring(6, 8));
  const today = new Date();
  const birthDateObj = new Date(year, month - 1, day);
  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
    age -= 1;
  }
  return age;
};

/**
 * 만 14세 미만 여부(법정대리인 동의 필요 대상).
 * 생년월일이 유효한 8자리이고 만 14세 미만일 때만 true.
 */
export const isUnder14 = (birthDate: string): boolean => {
  const age = getAge(birthDate);
  return age !== null && age < 14;
};

/**
 * Calculate end time from start time and duration
 * @param startTime - Start time in HH:mm format
 * @param durationHours - Duration in hours (default: 1)
 * @returns End time in HH:mm format
 */
export const getEndTime = (startTime: string, durationHours: number = 1): string => {
  const [hours, minutes] = startTime.split(':').map(Number);
  const endHour = (hours + durationHours) % 24;
  return `${endHour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};
